import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Link from 'flarum/common/components/Link';
import Button from 'flarum/common/components/Button';
import NagusiBackNav from '../common/NagusiBackNav';
import PlayerStatsModal from './PlayerStatsModal';
import ReportPlayerErrorModal from './ReportPlayerErrorModal';
export default class PlayerProfilePage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "player", null);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "error", null);
    // Lazy load state para el desglose detallado de valoraciones
    _defineProperty(this, "loadingVotes", false);
    _defineProperty(this, "cachedVotes", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.loadProfile();
  }
  async loadProfile() {
    this.loading = true;
    this.error = null;
    m.redraw();
    const slug = m.route.param('slug');
    if (!slug) {
      this.error = app.translator.trans('bizkaitarra-lineup.forum.player_profile.not_found');
      this.loading = false;
      m.redraw();
      return;
    }
    try {
      const res = await app.request({
        method: 'GET',
        url: "".concat(app.forum.attribute('apiUrl'), "/nagusi/match-ratings/player-profile/").concat(slug)
      });
      this.player = res.player;
      if (this.player) {
        app.setTitle(app.translator.trans('bizkaitarra-lineup.forum.player_profile.meta_title', {
          name: this.player.name
        }));
        if (this.player.isBirthdayToday) {
          setTimeout(() => this.triggerConfetti(), 300);
        }
      }
    } catch (e) {
      console.error('Error loading player profile:', e);
      this.error = app.translator.trans('bizkaitarra-lineup.forum.player_profile.not_found');
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  triggerConfetti() {
    const confettiCount = 50;
    const container = document.body;
    const baseUrl = app.forum.attribute('baseUrl').replace(/\/$/, '');
    const lionImgUrl = "".concat(baseUrl, "/api/custom-emojis/ee-leon-txapela");
    for (let i = 0; i < confettiCount; i++) {
      const el = document.createElement('div');
      el.className = 'birthday-confetti-particle';
      const isRed = Math.random() > 0.48;
      el.style.backgroundColor = isRed ? '#EE2523' : '#FFFFFF';
      if (!isRed) {
        el.style.boxShadow = '0 0 4px rgba(0, 0, 0, 0.25)';
      }
      el.style.left = "".concat(Math.random() * 100, "vw");
      el.style.top = '-20px';
      el.style.width = "".concat(Math.random() * 8 + 7, "px");
      el.style.height = "".concat(Math.random() * 12 + 8, "px");
      el.style.opacity = "".concat(Math.random() * 0.4 + 0.6);
      el.style.transform = "rotate(".concat(Math.random() * 360, "deg)");
      el.style.animation = "birthdayConfettiFall ".concat(Math.random() * 2.2 + 2.3, "s linear forwards");
      container.appendChild(el);
      setTimeout(() => el.remove(), 4800);
    }
    const lionCount = 10;
    for (let j = 0; j < lionCount; j++) {
      const lion = document.createElement('img');
      lion.className = 'birthday-confetti-lion';
      lion.src = lionImgUrl;
      lion.alt = 'León Athletic';
      lion.style.left = "".concat(Math.random() * 92 + 4, "vw");
      lion.style.top = '-50px';
      const size = Math.random() * 16 + 32;
      lion.style.width = "".concat(size, "px");
      lion.style.height = "".concat(size, "px");
      lion.style.animationDuration = "".concat(Math.random() * 2 + 2.8, "s");
      lion.style.animationDelay = "".concat(Math.random() * 0.7, "s");
      container.appendChild(lion);
      setTimeout(() => lion.remove(), 5500);
    }
  }

  /**
   * Carga bajo demanda (lazy loading) del historial detallado de partidos para la ventana modal
   */
  async openStatsModal() {
    if (!this.player || !this.player.ratingStats) return;
    const player = this.player;
    const stats = player.ratingStats;
    const showModalWithVotes = votes => {
      // Agrupar votos por partido para calcular medias y medianas por rival
      const matchGroups = {};
      votes.forEach(vote => {
        var _match$data;
        const match = typeof vote.match === 'function' ? vote.match() : vote.match || null;
        if (!match) return;
        const matchId = typeof match.id === 'function' ? match.id() : match.id || ((_match$data = match.data) == null ? void 0 : _match$data.id);
        if (!matchId) return;
        if (!matchGroups[matchId]) {
          const rival = typeof match.rival === 'function' ? match.rival() : match.rival || null;
          let opponentName = 'Rival';
          if (rival) {
            var _rival$attribute;
            opponentName = typeof rival.name === 'function' ? rival.name() : rival.name || ((_rival$attribute = rival.attribute) == null ? void 0 : _rival$attribute.call(rival, 'name')) || 'Rival';
          } else if (typeof match.opponent === 'function' && match.opponent()) {
            opponentName = match.opponent();
          } else if (match.attribute && match.attribute('opponent')) {
            opponentName = match.attribute('opponent');
          }
          const rawDate = match.attribute ? match.attribute('matchDate') : typeof match.matchDate === 'function' ? match.matchDate() : match.matchDate;
          const matchDate = rawDate instanceof Date ? rawDate.toISOString() : rawDate || '';
          matchGroups[matchId] = {
            opponent: opponentName,
            date: matchDate,
            ratings: []
          };
        }
        const rawRating = typeof vote.rating === 'function' ? vote.rating() : vote.attribute ? vote.attribute('rating') : vote.rating;
        const rating = parseFloat(rawRating) || 0;
        if (rating > 0) {
          matchGroups[matchId].ratings.push(rating);
        }
      });
      const history = Object.values(matchGroups).map(group => {
        const ratings = group.ratings.sort((a, b) => a - b);
        const count = ratings.length;
        const mid = Math.floor(count / 2);
        const median = count % 2 !== 0 ? ratings[mid] : (ratings[mid - 1] + ratings[mid]) / 2;
        const mean = count > 0 ? ratings.reduce((a, b) => a + b, 0) / count : 0;
        return {
          opponent: group.opponent,
          date: group.date,
          mean: mean.toFixed(2),
          median: median.toFixed(2)
        };
      }).sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
      app.modal.show(PlayerStatsModal, {
        player: {
          name: player.name,
          photoUrl: player.photoUrl,
          entityType: player.entityType || 'player',
          average: stats.average.toFixed(2),
          median: stats.median.toFixed(2),
          aaScore: stats.aaScore.toFixed(2),
          matchCount: stats.matchesCount,
          history: history
        },
        globalStats: {
          M: stats.globalM || 0,
          C: stats.C || 5
        }
      });
    };
    if (this.cachedVotes) {
      showModalWithVotes(this.cachedVotes);
      return;
    }
    this.loadingVotes = true;
    m.redraw();
    try {
      const teamId = player.teams && player.teams.length > 0 ? player.teams[0].id : undefined;
      const response = await app.request({
        method: 'GET',
        url: "".concat(app.forum.attribute('apiUrl'), "/nagusi/match-ratings/players/").concat(player.id, "/votes"),
        params: _objectSpread({
          season: stats.season
        }, teamId ? {
          teamId
        } : {})
      });
      const votes = app.store.pushPayload(response) || [];
      this.cachedVotes = votes;
      this.loadingVotes = false;
      m.redraw();
      showModalWithVotes(votes);
    } catch (err) {
      this.loadingVotes = false;
      console.error('Error fetching player votes on demand:', err);
      m.redraw();
    }
  }
  view() {
    if (this.loading) {
      return m("div", {
        className: "PlayerProfilePage"
      }, m("div", {
        className: "container",
        style: {
          padding: '60px 0',
          textAlign: 'center'
        }
      }, m(LoadingIndicator, null)));
    }
    if (this.error || !this.player) {
      return m("div", {
        className: "PlayerProfilePage"
      }, m("div", {
        className: "container",
        style: {
          padding: '60px 0',
          textAlign: 'center'
        }
      }, m("div", {
        className: "Alert Alert--error"
      }, this.error || 'Jugador no encontrado'), m(Link, {
        href: app.route('bizkaitarra-lineup.players'),
        className: "Button Button--primary",
        style: {
          marginTop: '20px'
        }
      }, app.translator.trans('bizkaitarra-lineup.forum.player_profile.back_to_directory'))));
    }
    const player = this.player;
    const isCoach = player.entityType === 'coach';
    const posKey = isCoach ? 'coach' : player.positionNormalized || 'default';
    const positionTrans = app.translator.trans("bizkaitarra-lineup.forum.players_directory.positions.".concat(posKey));
    const displayPosition = isCoach ? app.translator.trans('bizkaitarra-lineup.forum.players_directory.positions.coach') : positionTrans !== "bizkaitarra-lineup.forum.players_directory.positions.".concat(posKey) ? positionTrans : player.position || '-';
    return m("div", {
      className: "PlayerProfilePage"
    }, m("div", {
      className: "container"
    }, m(NagusiBackNav, {
      parentUrl: app.route('bizkaitarra-lineup.players'),
      parentLabel: app.translator.trans('bizkaitarra-lineup.forum.players_directory.nav_title'),
      title: player.name,
      rightContent: app.session.user ? m(Button, {
        className: "Button Button--secondary NagusiBackNav-reportBtn",
        icon: "fas fa-flag",
        onclick: () => {
          app.modal.show(ReportPlayerErrorModal, {
            player
          });
        }
      }, app.translator.trans('bizkaitarra-lineup.forum.players_directory.btn_report_error')) : null
    }), m("div", {
      className: "PlayerProfile-hero ".concat(player.isBirthdayToday ? 'is-birthday-today' : '')
    }, m("div", {
      className: "PlayerProfile-hero-card"
    }, m("div", {
      className: "PlayerProfile-avatar-wrap"
    }, player.photoUrl ? m("img", {
      src: player.photoUrl,
      alt: player.name,
      className: "PlayerProfile-avatar"
    }) : m("div", {
      className: "PlayerProfile-avatar PlayerProfile-avatar--placeholder"
    }, m("i", {
      className: "fas fa-user"
    })), !isCoach && player.number && m("span", {
      className: "PlayerProfile-dorsal"
    }, "#", player.number)), m("div", {
      className: "PlayerProfile-hero-details"
    }, m("div", {
      className: "PlayerProfile-hero-badges"
    }, m("span", {
      className: "PlayerCard-positionBadge PlayerCard-positionBadge--".concat(isCoach ? 'coach' : posKey)
    }, displayPosition), player.teams.map(t => m("span", {
      className: "PlayerProfile-teamBadge",
      key: t.id
    }, t.name)), player.isBirthdayToday && m("span", {
      className: "PlayerProfile-badgeBirthday"
    }, "\uD83C\uDF82 ", app.translator.trans('bizkaitarra-lineup.forum.player_profile.hero_birthday_today'))), m("h1", {
      className: "PlayerProfile-name"
    }, player.name), player.isBirthdayToday && m("p", {
      className: "PlayerProfile-birthdayAlert"
    }, "\uD83C\uDF89 ", app.translator.trans('bizkaitarra-lineup.forum.player_profile.birthday_banner', {
      age: player.age
    }))), app.session.user && m("div", {
      className: "PlayerProfile-hero-actions"
    }, m(Button, {
      className: "Button Button--secondary PlayerProfile-reportBtn",
      icon: "fas fa-flag",
      title: app.translator.trans('bizkaitarra-lineup.forum.players_directory.btn_report_error_tooltip'),
      onclick: () => {
        app.modal.show(ReportPlayerErrorModal, {
          player
        });
      }
    }, app.translator.trans('bizkaitarra-lineup.forum.players_directory.btn_report_error'))))), m("div", {
      className: "PlayerProfile-grid"
    }, m("div", {
      className: "PlayerProfile-card PlayerProfile-card--bio"
    }, m("h2", {
      className: "PlayerProfile-cardTitle"
    }, m("i", {
      className: "fas fa-id-card-alt"
    }), m("span", null, app.translator.trans('bizkaitarra-lineup.forum.player_profile.section_bio'))), m("div", {
      className: "PlayerProfile-infoList"
    }, !isCoach && m("div", {
      className: "PlayerProfile-infoRow"
    }, m("span", {
      className: "PlayerProfile-infoLabel"
    }, m("i", {
      className: "fas fa-tshirt"
    }), " ", app.translator.trans('bizkaitarra-lineup.forum.player_profile.label_dorsal')), m("span", {
      className: "PlayerProfile-infoValue"
    }, player.number ? "#".concat(player.number) : '-')), m("div", {
      className: "PlayerProfile-infoRow"
    }, m("span", {
      className: "PlayerProfile-infoLabel"
    }, m("i", {
      className: isCoach ? "fas fa-user-tie" : "fas fa-map-pin"
    }), " ", isCoach ? app.translator.trans('bizkaitarra-lineup.forum.player_profile.label_role') || 'Rol:' : app.translator.trans('bizkaitarra-lineup.forum.player_profile.label_position')), m("span", {
      className: "PlayerProfile-infoValue"
    }, displayPosition)), m("div", {
      className: "PlayerProfile-infoRow"
    }, m("span", {
      className: "PlayerProfile-infoLabel"
    }, m("i", {
      className: "fas fa-calendar-alt"
    }), " ", app.translator.trans('bizkaitarra-lineup.forum.player_profile.label_birthdate')), m("span", {
      className: "PlayerProfile-infoValue"
    }, player.birthDateFormatted || (player.birthDate ? player.birthDate.split('-').reverse().join('/') : null) ? "".concat(player.birthDateFormatted || player.birthDate.split('-').reverse().join('/')).concat(player.age !== null ? " (".concat(player.age, " ").concat(app.translator.trans('bizkaitarra-lineup.forum.players_directory.stat_years_abbr'), ")") : '') : '-')), m("div", {
      className: "PlayerProfile-infoRow"
    }, m("span", {
      className: "PlayerProfile-infoLabel"
    }, m("i", {
      className: "fas fa-globe-europe"
    }), " ", app.translator.trans('bizkaitarra-lineup.forum.player_profile.label_birthplace')), m("span", {
      className: "PlayerProfile-infoValue"
    }, player.birthPlace || '-')), m("div", {
      className: "PlayerProfile-infoRow"
    }, m("span", {
      className: "PlayerProfile-infoLabel"
    }, m("i", {
      className: "fas fa-ruler-vertical"
    }), " ", app.translator.trans('bizkaitarra-lineup.forum.player_profile.label_height')), m("span", {
      className: "PlayerProfile-infoValue"
    }, player.height || '-')), m("div", {
      className: "PlayerProfile-infoRow"
    }, m("span", {
      className: "PlayerProfile-infoLabel"
    }, m("i", {
      className: "fas fa-weight"
    }), " ", app.translator.trans('bizkaitarra-lineup.forum.player_profile.label_weight')), m("span", {
      className: "PlayerProfile-infoValue"
    }, player.weight || '-')))), m("div", {
      className: "PlayerProfile-card PlayerProfile-card--ratings"
    }, m("h2", {
      className: "PlayerProfile-cardTitle"
    }, m("i", {
      className: "fas fa-star-half-alt"
    }), m("span", null, app.translator.trans('bizkaitarra-lineup.forum.player_profile.section_ratings'))), player.ratingStats ? m("div", {
      className: "PlayerProfile-ratingsContent"
    }, m("div", {
      className: "PlayerProfile-scoreHighlight"
    }, m("div", {
      className: "PlayerProfile-scoreCircle"
    }, m("span", {
      className: "PlayerProfile-scoreNum"
    }, Number(player.ratingStats.average).toFixed(2)), m("span", {
      className: "PlayerProfile-scoreMax"
    }, "/ 10")), m("div", {
      className: "PlayerProfile-scoreMeta"
    }, m("h3", null, app.translator.trans('bizkaitarra-lineup.forum.player_profile.season_average_title', {
      season: player.ratingStats.season
    })), m("p", null, app.translator.trans('bizkaitarra-lineup.forum.player_profile.season_average_sub', {
      matches: player.ratingStats.matchesCount,
      votes: player.ratingStats.votesCount
    })))), m("div", {
      className: "PlayerProfile-statsGrid"
    }, m("div", {
      className: "PlayerProfile-statBox"
    }, m("span", {
      className: "PlayerProfile-statVal"
    }, Number(player.ratingStats.median).toFixed(2)), m("span", {
      className: "PlayerProfile-statKey"
    }, app.translator.trans('bizkaitarra-lineup.forum.player_profile.stat_median'))), m("div", {
      className: "PlayerProfile-statBox"
    }, m("span", {
      className: "PlayerProfile-statVal"
    }, Number(player.ratingStats.aaScore).toFixed(2)), m("span", {
      className: "PlayerProfile-statKey"
    }, "AA Score (Bayes)")), m("div", {
      className: "PlayerProfile-statBox"
    }, m("span", {
      className: "PlayerProfile-statVal"
    }, player.ratingStats.matchesCount), m("span", {
      className: "PlayerProfile-statKey"
    }, app.translator.trans('bizkaitarra-lineup.forum.player_profile.stat_matches'))), m("div", {
      className: "PlayerProfile-statBox"
    }, m("span", {
      className: "PlayerProfile-statVal"
    }, player.ratingStats.votesCount), m("span", {
      className: "PlayerProfile-statKey"
    }, app.translator.trans('bizkaitarra-lineup.forum.player_profile.stat_votes')))), m("div", {
      className: "PlayerProfile-modalTrigger"
    }, m(Button, {
      className: "Button Button--primary PlayerProfile-breakdownBtn",
      icon: this.loadingVotes ? undefined : 'fas fa-chart-line',
      loading: this.loadingVotes,
      disabled: this.loadingVotes,
      onclick: () => this.openStatsModal()
    }, app.translator.trans('bizkaitarra-lineup.forum.player_profile.btn_open_modal')), m("p", {
      className: "PlayerProfile-modalHint"
    }, app.translator.trans('bizkaitarra-lineup.forum.player_profile.modal_hint')))) : m("div", {
      className: "PlayerProfile-ratingsEmpty"
    }, m("i", {
      className: "fas fa-clipboard-list"
    }), m("p", null, app.translator.trans('bizkaitarra-lineup.forum.player_profile.no_ratings_yet')))), m("div", {
      className: "PlayerProfile-card PlayerProfile-card--birthday"
    }, m("h2", {
      className: "PlayerProfile-cardTitle"
    }, m("i", {
      className: "fas fa-birthday-cake"
    }), m("span", null, app.translator.trans('bizkaitarra-lineup.forum.player_profile.section_birthday'))), player.birthdayInfo || player.nextBirthday ? (() => {
      const bInfo = player.birthdayInfo;
      const isToday = bInfo ? bInfo.status === 'today' : player.isBirthdayToday;
      const isRecent = bInfo ? bInfo.isRecent : false;
      const isSigningOpen = bInfo ? bInfo.isSigningOpen : isToday;
      const targetSlug = bInfo ? bInfo.birthdaySlug : player.nextBirthday.birthdaySlug;
      const targetWishesCount = bInfo && typeof bInfo.wishesCount === 'number' ? bInfo.wishesCount : player.wishesCount;
      let titleText = '';
      let subText = '';
      let btnText = '';
      if (isToday) {
        titleText = app.translator.trans('bizkaitarra-lineup.forum.player_profile.today_bday_title', {
          age: (bInfo ? bInfo.age : player.age) || ''
        });
        subText = app.translator.trans('bizkaitarra-lineup.forum.player_profile.today_bday_sub');
        btnText = app.translator.trans('bizkaitarra-lineup.forum.player_profile.btn_wish_now');
      } else if (isRecent) {
        var _daysSince;
        titleText = app.translator.trans('bizkaitarra-lineup.forum.player_profile.recent_bday_title', {
          age: bInfo.age,
          days: (_daysSince = bInfo.daysSince) != null ? _daysSince : 0
        });
        const dateStr = app.translator.trans('bizkaitarra-lineup.forum.player_profile.recent_bday_date', {
          date: bInfo.dateFormatted
        });
        const statusStr = isSigningOpen ? app.translator.trans('bizkaitarra-lineup.forum.player_profile.recent_bday_sub_open') : app.translator.trans('bizkaitarra-lineup.forum.player_profile.recent_bday_sub_closed');
        subText = "".concat(dateStr, " ").concat(statusStr);
        btnText = isSigningOpen ? app.translator.trans('bizkaitarra-lineup.forum.player_profile.btn_wish_now') : app.translator.trans('bizkaitarra-lineup.forum.player_profile.btn_view_recent_guestbook');
      } else {
        const days = bInfo ? bInfo.daysRemaining : player.nextBirthday.daysRemaining;
        const date = bInfo ? bInfo.dateFormatted : player.nextBirthday.date;
        const age = bInfo ? bInfo.age : player.nextBirthday.ageTurning;
        titleText = app.translator.trans('bizkaitarra-lineup.forum.player_profile.next_bday_title', {
          days
        });
        subText = app.translator.trans('bizkaitarra-lineup.forum.player_profile.next_bday_date', {
          date,
          age
        });
        btnText = app.translator.trans('bizkaitarra-lineup.forum.player_profile.btn_view_guestbook');
      }
      return m("div", {
        className: "PlayerProfile-birthdayBox"
      }, m("div", {
        className: "PlayerProfile-birthdayBanner"
      }, m("div", {
        className: "PlayerProfile-birthdayIconWrap"
      }, m("i", {
        className: "fas fa-gift"
      })), m("div", {
        className: "PlayerProfile-birthdayText"
      }, m("h3", {
        className: isToday ? 'is-today-title' : ''
      }, titleText), m("p", null, subText))), m("div", {
        className: "PlayerProfile-wishesCTA"
      }, m("div", {
        className: "PlayerProfile-wishesCount"
      }, m("i", {
        className: "fas fa-comment-dots"
      }), m("span", null, app.translator.trans('bizkaitarra-lineup.forum.player_profile.wishes_count', {
        count: targetWishesCount
      }))), m(Link, {
        href: app.route('bizkaitarra-lineup.birthday', {
          slug: targetSlug
        }),
        className: "Button Button--primary PlayerProfile-wishesBtn"
      }, m("i", {
        className: "fas fa-feather-alt"
      }), m("span", null, btnText))));
    })() : m("div", {
      className: "PlayerProfile-ratingsEmpty"
    }, m("p", null, app.translator.trans('bizkaitarra-lineup.forum.player_profile.no_bday_data')))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/PlayerProfilePage', PlayerProfilePage);